import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { Helmet } from "react-helmet-async";

const PilihSemester = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [semester, setSemester] = useState([]); // Set default semester

  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const [formdata, setFormData] = useState({
    semester: '',
   
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(``);
    // Pastikan formdata tidak null atau undefined
    if (!formdata || Object.keys(formdata).length === 0) {
      setError('Data tidak boleh kosong');
      return;
    }
    console.log(formdata)

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/gantisemester`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
        body: JSON.stringify(formdata),
      });
      const result = await response.json();
      const data = result;
      
      console.log(data)
if (!response.ok) {
                throw new Error(result.message || "Gagal menyimpan data");
            }
                  localStorage.setItem('token', data.token);

            const step = data.step;
    if (step == 1) {
      navigate("/daftar/identifikasisekolah");
    } else if (step == 2) {
      navigate("/daftar/identifikasiaksess");
    } else if (step == 3) {
     if (data.data.akses == "Pendidik") {
          // navigate("/Pendidik");
          window.location.href = "/Pendidik";
        } else if (data.data.akses == "Operator") {
          // navigate("/admin");
           window.location.href = "/admin";
        } else if (data.data.akses == "Pd") {
          // navigate("/Pendidik");
          window.location.href = `/daftar/formBiodatapd?nama=${data.data.nama}`;
        } else  {
          window.location.href ="/daftar/identifikasisekolah";
        }

    }else if (step == 0) {
      if (data.data.akses == "Pendidik") {
          // navigate("/Pendidik");
          window.location.href = "/Pendidik";
        } else if (data.data.akses == "Operator") {
          // navigate("/admin");
           window.location.href = "/admin";
        } else if (data.data.akses == "Pd") {
          // navigate("/Pendidik");
          window.location.href = "/Pd";
        } else  {
          window.location.href ="/daftar/identifikasisekolah";
        }
    } else {
      navigate("/pilihsemester");
    }

 
        
      
    } catch (error) {
        console.log(error.message)
      setError(`Terjadi kesalahan: ${error.message}`);
    }
  };


useEffect(() => {
  const getInformasiAkun = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/usersweb/getsemester`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': "Bearer " + localStorage.getItem("token")
          },
          
        }
      );

      if (!response.ok) {
        throw new Error("Gagal mengambil data semester");
      }

      const result = await response.json();
      console.log("API Semester:", result);
const aktif = result.data.find(item => item.status === 1);
console.log(aktif.semester_id)
      // Simpan hanya array data semester

   
        setFormData({
                    semester: aktif.semester_id.toString()
                    })
      
     

      setSemester(result.data);

    } catch (error) {
      console.log(error.message);
      setError(`Terjadi kesalahan: ${error.message}`);
    }
  };

  getInformasiAkun();
}, []);



  return (
    <div>
      <Helmet>
        <title>Identifikasi Pengguna</title>
      </Helmet>
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
          <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary mt-3"><b>Hi, Selamat Datang</b></h4>
            <p className="text-muted">Lengkapi Biodata</p>
          </div>
          <form onSubmit={handleSubmit}>
           
            <div className="form-floating mb-3">
           <select
                className="form-control"
                name="semester"
                value={formdata.semester}
                onChange={(e)=> {
                    console.log(e.target.value)
                    setFormData({
                    ...formdata,
                    semester: e.target.value
                    })}
                }
                >
                <option value="">-- Pilih --</option>

                {semester.map((item, index) => (
                    <option key={index} value={item.semester_id}>
                    {item.nama}
                    </option>
                ))}
                </select>

              <label htmlFor="inputState">Semester</label>
            </div>
            {/* <div className="form-floating mb-3">
                    <input 
                      type="text"
                      value={formdata.noi}
                      name='noi'
                     
                      onChange={(e) => handleChange(e)} 
                      className="form-control" 
                      placeholder="No Induk Pegawai" 
                    />
                    <label htmlFor="floatingNama">No Induk Pegawai (Jika tidak ada Koosngkan Saja)</label>
                  </div>
                   */}

            <div className="d-grid mt-4">
              <button type="submit" className="btn btn-secondary">Lanjutkan</button>
            </div>
          </form>

          {error && <div className="alert alert-danger mt-2">{error}</div>}
          {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

          <hr />
        </div>
      </div>
    </div>
  );
};

export default PilihSemester;
